import React from 'react';
import Female_4_0 from '@/pages/intelligence/assets/imgs/gender/female_4_0.svg';
import Female_4_1 from '@/pages/intelligence/assets/imgs/gender/female_4_1.svg';
import Female_4_2 from '@/pages/intelligence/assets/imgs/gender/female_4_2.svg';
import Female_4_3 from '@/pages/intelligence/assets/imgs/gender/female_4_3.svg';
import Female_4_4 from '@/pages/intelligence/assets/imgs/gender/female_4_4.svg';
import Male_4_0 from '@/pages/intelligence/assets/imgs/gender/male_4_0.svg';
import Male_4_1 from '@/pages/intelligence/assets/imgs/gender/male_4_1.svg';
import Male_4_2 from '@/pages/intelligence/assets/imgs/gender/male_4_2.svg';
import Male_4_3 from '@/pages/intelligence/assets/imgs/gender/male_4_3.svg';
import Male_4_4 from '@/pages/intelligence/assets/imgs/gender/male_4_4.svg';
import './index.scss';

export default function MaleCard(props: any) {
  const { maleType, percentage } = props;
  // 创建并存储所有已导入的SVG图像
  const icons = {
    male: [Male_4_0, Male_4_1, Male_4_2, Male_4_3, Male_4_4],
    female: [Female_4_0, Female_4_1, Female_4_2, Female_4_3, Female_4_4],
  };

  const calculateIconCounts = (per) => {
    // 计算完整图标的数量
    // const wholeIcon = Math.floor(parseInt(per) / 10);
    let wholeIcon = Math.floor(parseInt(per) / 10);
    let halfIcon = parseFloat(per) % 10;

    // 根据余数确定半图标的索引：1 —— 1/4、2 —— 1/2、3 —— 3/4、0 —— 无半图标
    const iconIndex =
      halfIcon < 5 && halfIcon > 0
        ? 1
        : halfIcon === 5
        ? 2
        : halfIcon > 5
        ? 3
        : 0;

    // 根据计算结果创建表示完整图标、半图标和不可见图标的数组
    const noneIcon = 10 - wholeIcon - (iconIndex !== 0 ? 1 : 0);
    return { wholeIcon, iconIndex, noneIcon };
  };

  const createIconArray = (wholeIcon, iconIndex, noneIcon, maleType) => {
    // 根据计算结果创建表示完整图标、半图标和不可见图标的数组
    const arr = [
      ...Array(wholeIcon).fill({ type: 'whole', index: 4 }),
      ...(iconIndex
        ? [
            {
              type: ['none', 'quarter', 'half', 'threeQuarters'][iconIndex],
              index: iconIndex,
            },
          ]
        : []),
      ...Array(noneIcon).fill({ type: 'none', index: 0 }),
    ];
    // 使用 maleType 从对象 icons 中获取正确的 SVG 图标，并映射到数组上
    return arr.map((item) => ({
      ...item,
      icon: icons[maleType]?.[item.index],
    }));
  };

  // renderIconPercent 函数用于根据百分比和 maleType 确定要显示的图标
  const renderIconPercent = (per, maleType) => {
    const { wholeIcon, iconIndex, noneIcon } = calculateIconCounts(per);
    return createIconArray(wholeIcon, iconIndex, noneIcon, maleType);
  };

  return (
    <div className="dbi-genderRatio">
      <div className="dbi-genderRatio__img">
        {
          // 根据计算后的数组渲染图像并使用 alt 属性提供有意义的描述
          renderIconPercent(percentage, maleType).map((item) => (
            <img src={item.icon} alt={`${maleType}-${item.type}`} />
          ))
        }
      </div>
      <div className="dbi-genderRatio__per">
        <div className="dbi-genderRatio__per-value">{percentage}</div>
        <div className="dbi-genderRatio__per-text">Percentage</div>
      </div>
    </div>
  );
}
